// extracted by mini-css-extract-plugin
export default {"cardse":"Cards_cardse__-UlJ2","show":"Cards_show__59K9s","text":"Cards_text__5H33h","imgBlock":"Cards_imgBlock__+OuoP","img":"Cards_img__Ol0Rm"};